import { createReducer, on } from '@ngrx/store';
import {
  getInitialAssessment,
  getInitialAssessmentFailure,
  getInitialAssessmentSuccess,
  setAssessment,
  updateAssessment,
  updateAssessmentFailure,
  updateAssessmentSuccess,
} from '../actions/assessment.actions';
import { AssessmentPageState, AssessmentState } from '../models/assessment-models';

export const initialAssessmentState: AssessmentState = {
  testletConfig: {
    data: null,
    loading: false,
    error: null,
  },
};

export const getInitialAssessmentReducer = createReducer(
  initialAssessmentState,
  on(getInitialAssessment, (state) => ({
    ...state,
    testletConfig: {
      data: null,
      loading: true,
      error: null,
    },
  })),
  on(getInitialAssessmentSuccess, (state, { testletConfig }) => ({
    ...state,
    testletConfig: {
      data: testletConfig,
      loading: false,
      error: null,
    },
  })),
  on(getInitialAssessmentFailure, (state, { error }) => ({
    ...state,
    testletConfig: {
      data: null,
      loading: false,
      error,
    },
  })),
);

export const updateAssessmentReducer = createReducer(
  initialAssessmentState,
  on(updateAssessment, (state) => ({
    ...state,
    testletConfig: {
      data: null,
      loading: true,
      error: null,
    },
  })),
  on(updateAssessmentSuccess, (state, { testletConfig }) => ({
    ...state,
    testletConfig: {
      data: testletConfig,
      loading: false,
      error: null,
    },
  })),
  on(updateAssessmentFailure, (state, { error }) => ({
    ...state,
    testletConfig: {
      data: null,
      loading: false,
      error,
    },
  })),
);

export const initialAssessmentIdState: AssessmentPageState = {
  assessmentId: 0,
};

export const setAssessmentReducer = createReducer(
  initialAssessmentIdState,
  on(setAssessment, (state, { assessmentId }) => ({
    ...state,
    assessmentId: assessmentId,
  })),
);
